export function isSensitiveConfigKey(key: string) {
  const normalized = key.trim().toLowerCase();

  return (
    normalized.includes("key") ||
    normalized.includes("pass") ||
    normalized.includes("secret") ||
    normalized.includes("private")
  );
}
